export const fr = {
  nav: {
    home: "Accueil",
    finances: "Finances",
    wallets: "Wallets",
    countriesAndCurrencies: "Pays et monnaies",
    deposits: "Dépôts",
    withdrawals: "Retraits",
    conversionsAndReservations: "Conversion et réservations",
    virtualCards: "Cartes virtuelles",
    accounts: "Comptes",
    transactions: "Transactions",
    history: "Historique",
    pending: "En attente",
    paymentLinks: "Liens de paiement",
    team: "Équipe",
    developers: "Développeurs",
    appsAndWebhooks: "Applications et webhooks",
    apiDocumentation: "Documentation API",
    verification: "Vérification",
    settings: "Paramètres",
    notifications: "Notifications",
    assistant: "Agent",
    support: "Aide",
    supportAdmin: "Gestion du support",
    help: "Aide",
    logout: "Se déconnecter",
  },
  common: {
    save: "Enregistrer",
    saving: "Enregistrement…",
    cancel: "Annuler",
    confirm: "Confirmer",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    upload: "Téléverser",
    send: "Envoyer",
    download: "Télécharger",
    copy: "Copier",
    copied: "Copié !",
    retry: "Réessayer",
    loading: "Chargement…",
    search: "Rechercher",
    filter: "Filtrer",
    all: "Tous",
    close: "Fermer",
    viewAll: "Voir tout",
    details: "Détails",
    actions: "Actions",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    refresh: "Actualiser",
    status: "Statut",
    date: "Date",
    amount: "Montant",
    currency: "Devise",
    country: "Pays",
    reference: "Référence",
    type: "Type",
    recipient: "Bénéficiaire",
    unknown: "Inconnu",
    empty: "Aucun élément trouvé",
    success: "Opération réussie",
    error: "Une erreur est survenue",
    active: "Actif",
    inactive: "Inactif",
    enabled: "Activé",
    disabled: "Désactivé",
    na: "—",
  },
  operations: {
    DEPOSIT: "Dépôt",
    PAYIN: "Encaissement",
    PAYOUT: "Décaissement",
    REFUND: "Remboursement",
    TRANSFER_IN: "Transfert reçu",
    TRANSFER_OUT: "Transfert envoyé",
    WITHDRAWAL: "Retrait",
    TRANSFER: "Transfert",
    NOTIFICATION_PLAN_SUBSCRIPTION: "Abonnement notifications",
  },
  statuses: {
    COMPLETED: "Terminée",
    FAILED: "Échouée",
    PENDING: "En attente",
    PROCESSING: "En traitement",
    ACTIVE: "Actif",
    SUSPENDED: "Suspendu",
    CLOSED: "Fermé",
    APPROVED: "Approuvé",
    REJECTED: "Rejeté",
    SUBMITTED: "Soumis",
    UNDER_REVIEW: "En cours d'examen",
    DRAFT: "Brouillon",
  },
  methods: {
    card: "Carte bancaire",
    internal: "Transfert interne",
    mobile_money: "Mobile Money",
    mtn: "MTN Mobile Money",
    orange: "Orange Money",
    wave: "Wave",
  },
  topbar: {
    searchPlaceholder: "Rechercher une transaction (référence, contrepartie)…",
    notifications: "Notifications",
    markAllRead: "Voir tout",
    noNotifications: "Aucune notification",
    help: "Aide",
    helpTitle: "Centre d’aide",
    helpDesc:
      "Consultez la documentation API ou contactez le support BizConnectPay pour votre intégration.",
    accountMenu: "Menu du compte",
    accountDefault: "Compte BizConnectPay",
    settings: "Paramètres",
    logout: "Se déconnecter",
    language: "Langue",
    serviceStatus: "État des services",
    statusIntro: "Incidents et maintenances publiés par BizConnectPay.",
    incidents: "Incidents",
    maintenance: "Maintenance",
    noIncidents: "Aucun incident publié.",
    noMaintenance: "Aucune maintenance publiée.",
    statusHistory: "Consulter l’historique complet",
  },
  overview: {
    title: "Accueil",
    subWelcome: "Bienvenue, {name} · {space}",
    businessSpace: "Espace entreprise",
    individualSpace: "Compte individuel",
    deposit: "Dépôt",
    withdraw: "Retrait",
    transfer: "Transfert",
    loadingOverview: "Chargement de l’aperçu…",
    paymentOverview: "Aperçu des paiements",
    periodSub: "Opérations terminées sur la période",
    transactions: "Transactions",
    transactionsHint: "Nombre de paiements exécutés et complétés",
    totalVolume: "Volume total",
    totalVolumeHint: "Somme des volumes convertis et traités",
    activeMarkets: "Marchés actifs",
    activeMarketsHint: "Pays dans lesquels des transactions ont abouti",
    balancesAndWallets: "Soldes et Wallets",
    walletsSub: "Soldes disponibles par pays et devise",
    allWallets: "Gérer les wallets",
    recentTransactions: "Transactions récentes",
    recentSub: "Dernières opérations enregistrées",
    allTransactions: "Toutes les transactions",
    emptyTxs: "Aucune transaction enregistrée pour le moment.",
    complianceBannerTitle: "Vérification de compte ({type})",
    compliancePending:
      "Votre dossier est en cours de constitution. Veuillez soumettre vos pièces justificatives.",
    complianceUnderReview:
      "Votre dossier a été transmis et est actuellement en cours d'examen par notre équipe.",
    complianceApproved: "Votre compte est entièrement vérifié et opérationnel.",
    goToVerification: "Accéder à la vérification",
    quickActions: "Actions rapides",
  },
  wallets: {
    title: "Wallets",
    sub: "Gérez vos comptes en devises locales et internationales.",
    countriesAndNewWallet: "Pays et nouveau wallet",
    filterCurrency: "Filtrer par devise",
    filterStatus: "Filtrer par statut",
    allCurrencies: "Toutes devises",
    allStatuses: "Tous statuts",
    refreshWallets: "Actualiser les wallets",
    emptyWallets:
      "Aucun wallet ne correspond. Le wallet principal de votre pays est provisionné par BizConnectPay à l'inscription.",
    availableBalance: "Solde disponible",
    totalBalance: "Solde total",
    walletType: "Type de wallet",
    scope: "Portée",
    local: "Local",
    international: "International",
    deposit: "Dépôt",
    withdraw: "Retrait",
    transfer: "Transfert",
    transactionsForWallet: "Transactions de ce wallet",
    emptyWalletTxs: "Aucune transaction pour ce wallet.",
    catalogTitle: "Pays disponibles et ouverture de wallet",
    catalogSub:
      "Découvrez les devises acceptées et ouvrez un wallet supplémentaire.",
    openWalletBtn: "Ouvrir un wallet",
    openWalletSuccess: "Nouveau wallet ouvert avec succès !",
  },
  transactions: {
    title: "Transactions",
    sub: "Historique complet de vos opérations financières et paiements.",
    exportCsv: "Exporter CSV",
    filterAll: "{label} : tous",
    searchPlaceholder: "Filtrer par référence, tiers, description…",
    allCurrencies: "Toutes devises",
    allStatuses: "Tous statuts",
    allOperations: "Toutes opérations",
    emptyTransactions: "Aucune transaction ne correspond à vos filtres.",
    referenceCol: "Référence",
    typeCol: "Type",
    amountCol: "Montant",
    feeCol: "Frais",
    statusCol: "Statut",
    dateCol: "Date",
    detailsBtn: "Consulter",
  },
  verification: {
    title: "Vérification & Conformité",
    subKyb:
      "Vérification d'entreprise (KYB) · Documents et pièces justificatives",
    subKyc:
      "Vérification d'identité (KYC) · Pièces justificatives personnelles",
    rulesTitle: "Règles de conformité pour validation",
    requiredDocsTitle: "Pièces requises pour votre compte",
    doneOf: "{done} sur {total} pièces fournies selon le serveur",
    serverList: "Liste fournie par le serveur",
    selectedCount: "{count} pièce(s) sélectionnée(s)",
    selectedBatchDesc:
      "Vous pouvez envoyer tous les documents sélectionnés en une seule action.",
    uploadAll: "Tout téléverser ({count})",
    uploadingBatch: "Envoi {current}/{total}…",
    noRequirements: "Aucune exigence renvoyée",
    noRequirementsSub:
      "Le serveur n'a pas listé de documents requis pour ce dossier.",
    missingDocs: "Pièces manquantes : {list}",
    addExtraDocTitle: "Ajouter un autre document",
    addExtraDocSub: "Téléversement direct pour le dossier {type}",
    categoryLabel: "Catégorie",
    chooseCategory: "Choisir la catégorie",
    fileLabel: "Fichier (PDF, JPG, PNG)",
    noDocsSaved: "Aucun document enregistré",
    noDocsSavedSub: "Les pièces transmises apparaîtront ici.",
    viewMetadata: "Voir métadonnées",
    contractTitle: "Contrat d'agrégation marchande",
    contractSub:
      "Téléchargez le contrat, signez-le puis téléversez la version signée.",
    noContract: "Aucun contrat émis",
    noContractSub:
      "Le contrat apparaîtra ici dès qu'il aura été généré pour votre compte entreprise.",
    consultContract: "Consulter",
    downloadContract: "Télécharger le contrat",
    uploadSigned: "Envoyer la version signée",
    caseStatusTitle: "Statut du dossier",
    businessAccount: "Compte entreprise",
    individualAccount: "Compte individuel",
    statusApproved:
      "Votre dossier est approuvé. Toutes les fonctionnalités de paiement sont actives.",
    statusInReview:
      "Votre dossier a été soumis et est actuellement en cours d'examen par notre équipe de conformité.",
    statusPending:
      "Votre dossier est en cours de constitution. Fournissez toutes les pièces avant de le soumettre.",
    lockedWarning:
      "Les encaissements et retraits restent restreints jusqu'à la validation complète du dossier.",
    finalSubmission: "Soumission finale",
    completeTitle: "Dossier complet",
    completeDesc:
      "Toutes les pièces requises sont fournies. Vous pouvez désormais transmettre votre dossier pour validation.",
    incompleteDesc:
      "Transmettez l'ensemble des pièces requises ci-contre avant de pouvoir soumettre le dossier.",
    submitButton: "Soumettre le dossier",
    alreadySubmitted: "Dossier déjà soumis",
    confirmTitle: "Soumettre le dossier {type} ?",
    confirmDesc:
      "Une fois soumis, le dossier passera en cours d'examen (statut UNDER_REVIEW). Il ne pourra plus être modifié pendant l'analyse de notre équipe de conformité.",
    confirmButton: "Confirmer la soumission",
    metadataTitle: "Métadonnées de la pièce",
    openCaseTitle: "Ouvrir un dossier de vérification",
    openCaseSub:
      "Le type ({type}) est déterminé par le serveur selon votre compte actif.",
    caseLanguage: "Langue du dossier",
    createCaseButton: "Créer le dossier",
    chooseFileFirst: "Sélectionnez d'abord un fichier.",
    chooseCategoryAndFile: "Choisissez une catégorie et un fichier.",
    uploadSuccess: "Document {category} téléversé avec succès.",
    batchSuccess: "{count} document(s) téléversé(s) avec succès !",
    batchError: "Erreur lors du téléversement de certains documents.",
    signedUploadSuccess: "Contrat signé téléversé avec succès.",
    submitSuccess:
      "Dossier de vérification soumis avec succès ! Il est actuellement en cours d'examen.",
    categories: {
      IDENTITY_DOCUMENT: {
        label: "Pièce d'identité officielle",
        desc: "Carte Nationale d'Identité (recto-verso), Passeport valide ou Titre de séjour.",
      },
      IDENTITY_RECEIPT: {
        label: "Récépissé d'identité",
        desc: "Récépissé officiel d'une demande de carte nationale d'identité.",
      },
      ELECTION_CARD: {
        label: "Carte d'électeur",
        desc: "Carte d'électeur officielle, valide et lisible.",
      },
      NATIONAL_ID: {
        label: "Carte nationale d'identité",
        desc: "Carte nationale d'identité en cours de validité, recto-verso.",
      },
      CNI: {
        label: "Carte nationale d'identité",
        desc: "Carte nationale d'identité en cours de validité, recto-verso.",
      },
      PASSPORT: {
        label: "Passeport",
        desc: "Passeport en cours de validité.",
      },
      DRIVER_LICENSE: {
        label: "Permis de conduire",
        desc: "Permis de conduire officiel en cours de validité.",
      },
      SELFIE_WITH_ID: {
        label: "Selfie avec la pièce d'identité",
        desc: "Photo claire de votre visage tenant la pièce d'identité bien visible et lisible.",
      },
      ADDRESS_PROOF: {
        label: "Justificatif de domicile récent",
        desc: "Facture d'eau/électricité, quittance de loyer ou attestation de résidence (< 3 mois).",
      },
      BUSINESS_ADDRESS_PROOF: {
        label: "Justificatif de siège social",
        desc: "Contrat de bail commercial, quittance de loyer ou facture de service public au nom de la société.",
      },
      PROOF_OF_BUSINESS_ADDRESS: {
        label: "Justificatif de siège social",
        desc: "Contrat de bail commercial ou facture de service public au nom de la société.",
      },
      BENEFICIAL_OWNER_LIST: {
        label: "Liste des bénéficiaires effectifs",
        desc: "Document officiel déclarant l'ensemble des associés ou bénéficiaires effectifs détenant au moins 25% du capital.",
      },
      BUSINESS_REGISTRATION: {
        label: "Registre du Commerce (RCCM)",
        desc: "Extrait du Registre du Commerce et du Crédit Mobilier (RCCM) ou certificat d'immatriculation officiel.",
      },
      REGISTRATION_CERTIFICATE: {
        label: "Registre de Commerce (RCCM)",
        desc: "Extrait RCCM ou certificat d'immatriculation officiel de l'entreprise.",
      },
      BUSINESS_TAX_CERTIFICATE: {
        label: "Attestation d'immatriculation fiscale (NIF)",
        desc: "Numéro d'Identifiant Fiscal (NIF) officiel, attestation de non-redevance ou carte active.",
      },
      TAX_IDENTIFICATION_DOCUMENT: {
        label: "Numéro d'Identifiant Fiscal (NIF)",
        desc: "Attestation d'immatriculation fiscale ou carte de contribuable active.",
      },
      TAX_CLEARANCE: {
        label: "Attestation de régularité fiscale",
        desc: "Attestation de non-redevance délivrée par l'administration des impôts.",
      },
      ARTICLES_OF_INCORPORATION: {
        label: "Statuts de l'entreprise",
        desc: "Statuts constitutifs signés et enregistrés ou acte notarié officiel.",
      },
      BANK_STATEMENT: {
        label: "Relevé d'Identité Bancaire (RIB)",
        desc: "Relevé de compte bancaire professionnel au nom légal de l'entreprise.",
      },
      REPRESENTATIVE_ID: {
        label: "Pièce d'identité du représentant légal",
        desc: "CNI ou passeport du gérant ou administrateur mentionné dans les statuts.",
      },
      POWER_OF_ATTORNEY: {
        label: "Procuration légale / Mandat",
        desc: "Acte notarié ou pouvoir autorisant le mandataire à représenter la société.",
      },
      SIGNED_BUSINESS_CONTRACT: {
        label: "Contrat d'agrégation d'entreprise signé",
        desc: "Contrat de service BizConnectPay paraphé, signé et cacheté par le représentant légal.",
      },
      SIGNED_CONTRACT: {
        label: "Contrat d'agrégation d'entreprise signé",
        desc: "Contrat de service BizConnectPay paraphé, signé et cacheté par le représentant légal.",
      },
      FINANCIAL_STATEMENTS: {
        label: "États financiers certifiés",
        desc: "Bilan ou compte de résultat certifié du dernier exercice clos.",
      },
      SHAREHOLDER_REGISTER: {
        label: "Registre des associés / actionnaires",
        desc: "Registre des mouvements de titres ou liste officielle des actionnaires.",
      },
    },
    statuses: {
      NOT_STARTED: "NON DÉMARRÉ",
      PENDING: "EN ATTENTE",
      UNDER_REVIEW: "EN COURS D'EXAMEN",
      IN_REVIEW: "EN COURS D'EXAMEN",
      SUBMITTED: "SOUMIS",
      APPROVED: "APPROUVÉ",
      REJECTED: "REJETÉ",
      MORE_INFORMATION_REQUIRED: "COMPLÉMENT REQUIS",
      SIGNED_RECEIVED: "CONTRAT SIGNÉ REÇU",
      DRAFT: "BROUILLON",
      ACTIVE: "ACTIF",
      UPLOADED: "TRANSMIS",
    },
    contractStatuses: {
      PENDING: "EN ATTENTE DE SIGNATURE",
      SIGNED_RECEIVED: "CONTRAT SIGNÉ REÇU",
      SIGNED: "SIGNÉ",
      APPROVED: "VALIDÉ",
      REJECTED: "REJETÉ",
      DRAFT: "BROUILLON",
      ACTIVE: "ACTIF",
    },
    rules: {
      "Company information must match official registration records.":
        "Les informations de l'entreprise doivent correspondre aux registres officiels d'immatriculation.",
      "Every beneficial owner must be declared.":
        "Chaque bénéficiaire effectif détenant au moins 25% du capital doit être déclaré.",
      "All submitted documents must be valid and readable.":
        "Tous les documents soumis doivent être valides, lisibles et non expirés.",
      "The authorized representative must sign and return the BizConnectPay service agreement.":
        "Le représentant légal autorisé doit signer et téléverser le contrat de service BizConnectPay.",
      "Documents must be valid, readable, and unexpired.":
        "Les documents doivent être valides, lisibles et en cours de validité.",
      "The account holder name must match the identity document.":
        "Le nom du titulaire du compte doit correspondre exactement à la pièce d'identité.",
      "Proof of address must be recent.":
        "Le justificatif de domicile doit dater de moins de 3 mois.",
    },
  },
  settings: {
    title: "Paramètres",
    sub: "Profil du compte, langue d'affichage, préférences de notification et consultation des frais.",
    tabProfile: "Profil & Langue",
    tabNotifications: "Préférences de notification",
    tabFees: "Frais & Tarification",
    profileTitle: "Profil",
    fullName: "Nom complet",
    email: "E-mail",
    emailLockedHint:
      "L’adresse e-mail est verrouillée et ne peut pas être modifiée.",
    phone: "Téléphone",
    saveProfileBtn: "Enregistrer le profil",
    profileSavedToast: "Profil enregistré avec succès",
    notificationsTitle: "Préférences de notification",
    notificationsSub:
      "Configurez les canaux de réception pour vos alertes de sécurité et de transaction.",
    channelEmail: "E-mail",
    channelSms: "SMS",
    channelPush: "Navigateur",
    channelInApp: "Dans l’application",
    channelWhatsApp: "WhatsApp",
    channelEmailSub: "Alertes envoyées à votre adresse e-mail",
    channelSmsSub: "Alertes envoyées par SMS",
    channelPushSub: "Notifications dans le tableau de bord",
    channelInAppSub: "Notifications visibles dans votre espace",
    channelWhatsAppSub: "Alertes envoyées sur votre numéro WhatsApp",
    eventPaymentCompleted: "Paiement réussi",
    eventKycApproved: "KYC approuvé",
    eventKybApproved: "KYB approuvé",
    prefSavedToast: "Préférence enregistrée",
    languageSectionTitle: "Langue d'affichage",
    languageSectionSub:
      "Choisissez votre langue préférée pour naviguer sur la console.",
    feesTitle: "Frais COLLECTION & DISTRIBUTION",
    feesSub:
      "Consultez les taux fixes appliqués sur vos encaissements (COLLECTION) et vos retraits (DISTRIBUTION) et simulez vos opérations.",
    collectionFeeTitle: "Encaissement (COLLECTION / Dépôt)",
    collectionFeeDesc:
      "Appliqué sur les liens de paiement, dépôts et paiements API (/v1/payments). Vous pouvez choisir si les frais sont supportés par le marchand ou facturés au client.",
    distributionFeeTitle: "Décaissement (DISTRIBUTION / Retrait)",
    distributionFeeDesc:
      "Mode B : Le bénéficiaire reçoit le montant exact demandé et les frais sont ajoutés au débit de votre wallet.",
    internalTransferFeeTitle: "Transfert interne (BCP vers BCP)",
    internalTransferFeeDesc:
      "Transferts instantanés entre comptes BizConnectPay.",
    feeSimulatorTitle: "Simulateur de frais en temps réel",
    feeSimulatorSub:
      "Simulez le montant facturé au client, les frais retenus et le montant net crédité ou débité sur votre wallet.",
    simOperation: "Type d'opération",
    simOperationCollection: "Encaissement (COLLECTION / Dépôt)",
    simOperationDistribution: "Décaissement (DISTRIBUTION / Retrait)",
    simAmount: "Montant de base",
    simCurrency: "Devise",
    simFeePayer: "Qui paie les frais ?",
    simPayerMerchant: "Marchand (déduits du montant)",
    simPayerCustomer: "Client (ajoutés au montant à payer)",
    simCustomerPays: "Montant facturé au client",
    simFeeAmount: "Frais BizConnectPay",
    simMerchantNet: "Crédité sur le wallet marchand",
    simBeneficiaryReceives: "Reçu par le bénéficiaire",
    simWalletTotalDebit: "Débit total sur le wallet marchand",
    feePayerLabel: "Prise en charge des frais d'encaissement",
    feePayerMerchantOption: "Marchand — Frais déduits du montant reçu",
    feePayerCustomerOption:
      "Client — Frais ajoutés au montant payé par le client",
    feePayerSavedToast: "Prise en charge des frais mise à jour",
    tabSecurity: "Sécurité & 2FA",
    channelComingSoon: "Bientôt disponible",
    channelComingSoonTooltip:
      "Ce canal n'est pas encore activé sur la plateforme.",
    twoFactorTitle: "Authentification à deux facteurs (2FA)",
    twoFactorSub:
      "Protégez l'accès à votre compte marchand avec un code de vérification à usage unique (OTP).",
    twoFactorStatus: "Statut 2FA",
    twoFactorEnabled: "Activée",
    twoFactorDisabled: "Désactivée",
    twoFactorActiveChannel: "Canal actif",
    twoFactorChannelSelect: "Sélectionnez le canal de réception du code OTP",
    twoFactorChannelEmail: "E-mail (Recommandé)",
    twoFactorChannelSms: "SMS (Téléphone)",
    twoFactorChannelWhatsApp: "WhatsApp",
    twoFactorSendOtpBtn: "Envoyer le code OTP",
    twoFactorSending: "Envoi en cours…",
    twoFactorOtpLabel: "Code de vérification (6 chiffres)",
    twoFactorOtpPlaceholder: "Ex: 123456",
    twoFactorConfirmBtn: "Valider et activer la 2FA",
    twoFactorDisableBtn: "Désactiver la 2FA",
    twoFactorDisableConfirm:
      "Êtes-vous certain de vouloir désactiver l'authentification à deux facteurs ?",
    twoFactorRecoveryTitle: "Codes de secours (Important)",
    twoFactorRecoverySub:
      "Enregistrez ces codes de secours dans un endroit sûr. Chacun ne peut être utilisé qu'une seule fois si vous perdez l'accès à votre canal 2FA.",
    twoFactorRecoveryClose: "J'ai bien enregistré mes codes",
    twoFactorSuccessToast:
      "Authentification à deux facteurs activée avec succès !",
    twoFactorDisabledToast: "Authentification à deux facteurs désactivée.",
  },
  auth: {
    twoFactorTitle: "Authentification à deux facteurs (2FA)",
    twoFactorSub:
      "Un code de sécurité à 6 chiffres a été envoyé par {channel} à {destination}.",
    twoFactorCodeLabel: "Code de sécurité (6 chiffres ou code de secours)",
    twoFactorPlaceholder: "123456",
    twoFactorResendBtn: "Renvoyer le code",
    twoFactorResending: "Renvoi…",
    twoFactorResentToast: "Nouveau code envoyé avec succès !",
    twoFactorVerifyBtn: "Valider et se connecter",
    twoFactorBackBtn: "Retour à la connexion",
    loginBadge: "Espace marchand sécurisé",
    loginHeroTitle:
      "Encaissez, décaissez et pilotez vos activités depuis un seul espace.",
    loginHeroSub:
      "Consultez vos wallets, transactions, vérifications et intégrations API BizConnectPay.",
    loginHeroFooter:
      "© 2026 BizConnectPay. Connexion chiffrée de bout en bout.",
    loginCategory: "Connexion marchand",
    loginWelcome: "Bienvenue",
    loginSub: "Connectez-vous à votre espace marchand BizConnectPay.",
    emailLabel: "Adresse e-mail",
    emailPlaceholder: "nom@entreprise.com",
    passwordLabel: "Mot de passe",
    passwordPlaceholder: "••••••••",
    accountIdOptional: "ID de compte (optionnel)",
    accountTypeOptional: "Espace de connexion (optionnel)",
    workspaceBusiness: "Espace Entreprise",
    workspaceIndividual: "Espace Particulier",
    defaultWorkspace: "Espace par défaut",
    signInBtn: "Se connecter",
    signingIn: "Connexion en cours…",
    noAccount: "Nouveau sur BizConnectPay ?",
    registerLink: "Créer un compte",
    forgotPasswordLink: "Mot de passe oublié ?",
    resendVerificationLink: "Renvoyer l'e-mail de vérification",
    orDivider: "ou",
    registerBadge: "Ouverture de compte",
    registerHeroTitle:
      "La passerelle de paiement unifiée pour l'Afrique et l'international.",
    registerHeroSub:
      "Intégrez Orange Money, MTN, Wave, cartes bancaires et virements en une seule API.",
    registerCategory: "Nouveau compte marchand",
    registerTitle: "Créer votre compte",
    registerSub: "Renseignez vos coordonnées pour démarrer votre intégration.",
    businessType: "Entreprise / Société",
    individualType: "Particulier / Professionnel",
    registerHeroCompliance:
      "© 2026 BizConnectPay. Conforme aux normes bancaires et CEMAC/UEMOA.",
    accountTypeLabel: "Type de compte",
    businessKyb: "Entreprise (KYB)",
    businessKybDesc: "Sociétés, SARL, SAS",
    individualKyc: "Individuel (KYC)",
    individualKycDesc: "Freelances & Particuliers",
    operatingCountry: "Pays d'opération",
    countryHelp:
      "La disponibilité des paiements dépend du catalogue BizConnectPay.",
    phoneHelp:
      "Saisissez le numéro sans l’indicatif. Changer de pays efface le numéro.",
    matriculeLabel: "Votre matricule unique et immuable :",
    verifyEmailNotice:
      "Un e-mail de vérification a été envoyé à {email}. Ouvrez le lien reçu pour confirmer votre adresse.",
    kybPendingNotice:
      "Votre compte reste en attente de vérification {type} : les opérations financières ne sont pas encore autorisées.",
    resendSuccess: "Demande envoyée.",
    resendFailed: "Envoi impossible, réessayez.",
    creatingAccount: "Création du compte…",
    businessNameLabel: "Nom entreprise",
    individualNameLabel: "Nom d’usage",
    createAccountBtn: "Créer mon compte",
    alreadyRegistered: "Vous avez déjà un compte ?",
    signInLink: "Connectez-vous",
    registrationSuccessTitle: "Compte créé avec succès !",
    registrationSuccessSub:
      "Veuillez vérifier votre adresse email pour activer votre compte.",
  },
  cards: {
    title: "Cartes virtuelles",
    sub: "Émettez des cartes virtuelles prépayées Visa et Mastercard pour vos dépenses.",
    subBlocked: "Émission et gestion de cartes virtuelles.",
    subSensitive:
      "Les détails sensibles ne sont jamais conservés par BizConnectPay.",
    unavailableTitle: "Cartes indisponibles",
    unavailableSub:
      "Votre compte n'est pas encore autorisé pour les opérations financières. Terminez votre KYC.",
    createCard: "Nouvelle carte",
    cardholderBtn: "Titulaire",
    issueCardBtn: "Émettre une carte",
    cardsPanel: "Cartes",
    cardholdersPanel: "Titulaires",
    emptyCards: "Aucune carte",
    emptyCardsSub: "Créez un titulaire puis émettez votre première carte.",
    emptyHolders: "Aucun titulaire",
    emptyHoldersSub: "Un titulaire est requis avant toute émission.",
    openCardBtn: "Ouvrir",
    cardFallback: "Carte",
    freezeCard: "Bloquer la carte",
    unfreezeCard: "Débloquer la carte",
    cardHolder: "Titulaire",
    cardNumber: "Numéro de carte",
    expiration: "Expiration",
    cvv: "CVV",
  },
  team: {
    title: "Gestion d'équipe",
    sub: "Invitez vos collaborateurs et gérez leurs rôles et permissions d'accès.",
    pageSub: "Membres, rôles et invitations de l'espace entreprise.",
    inviteMember: "Inviter un membre",
    inviteBtn: "Inviter",
    summaryTitle: "Résumé",
    summarySub: "Votre adhésion et l'équipe",
    yourRole: "Votre rôle :",
    assignableRolesTitle: "Rôles assignables",
    searchPlaceholder: "Nom ou e-mail",
    allStatuses: "Tous statuts",
    emptyMembers: "Aucun membre trouvé",
    removeTitle: "Retirer le membre",
    removeConfirm: "Voulez-vous vraiment retirer ce membre de votre équipe ?",
    roleOwner: "Propriétaire",
    roleAdmin: "Administrateur",
    roleDeveloper: "Développeur",
    roleFinance: "Responsable financier",
    roleViewer: "Lecteur seul",
  },
  developers: {
    title: "Espace Développeurs",
    sub: "Clés d'API, documentation et configuration des webhooks en temps réel.",
    pageTitle: "Applications",
    pageSub:
      "Gestion via votre session (Bearer). Vos serveurs utilisent les identifiants Basic de l'application, jamais ce navigateur.",
    docsBtn: "Documentation API ↗",
    newAppBtn: "Nouvelle application",
    emptyApps: "Aucune application",
    emptyAppsSub: "Créez-en une pour obtenir des identifiants.",
    apiKeys: "Clés d'API",
    createKey: "Générer une clé",
    webhooks: "Webhooks",
    createWebhook: "Ajouter un endpoint",
    docsLink: "Consulter la documentation interactive",
  },
  merchantAssistant: {
    title: "Assistant marchand",
    subtitle: "Un guide intelligent qui connaît votre espace BizConnectPay.",
    notReadyTitle: "Assistant désactivé",
    notReadyBody:
      "BizConnectPay a temporairement désactivé l’assistant. Il réapparaîtra dans votre tableau de bord dès sa réactivation.",
    privateKeyNote:
      "Lorsque l’IA externe est désactivée, les réponses viennent de la base locale. Les identifiants IA restent côté serveur.",
    consentTitle:
      "Autoriser l’assistant à consulter le contexte de votre compte ?",
    consentBody:
      "Pour répondre et préparer des rapports, certaines données peuvent être traitées localement. Elles ne sont envoyées au fournisseur IA que si BizConnectPay autorise les appels externes. Le traitement commence après votre accord.",
    consentData1: "Soldes disponibles et bloqués de vos portefeuilles actifs.",
    consentData2:
      "Totaux des transactions par statut, devise et opération sur les 30 derniers jours.",
    consentData3:
      "Jusqu’à 12 transactions récentes, sans numéro de téléphone ni données de carte.",
    consentCheckbox:
      "J’accepte le traitement de ce contexte de compte par l’assistant. Mes conversations et mes notes mémoire seront enregistrées dans mon espace et je pourrai les supprimer.",
    enable: "Activer l’assistant",
    enableFailed: "Impossible d’activer l’assistant",
    notReady: "Non configuré",
    banner:
      "Posez vos questions sur vos paiements, vos portefeuilles et les opérations qui nécessitent votre attention.",
    newChat: "Nouvelle conversation",
    greeting: "Bonjour ! Je suis votre assistant BizConnectPay.",
    greetingSub:
      "Je peux vous aider à comprendre les informations de votre compte et à trouver les prochaines étapes.",
    quickActions: "Actions rapides",
    quick: [
      "Résume mes paiements récents et mes soldes.",
      "Quelles transactions récentes nécessitent mon attention ?",
      "Explique les frais et le règlement de mon compte.",
    ],
    inputPlaceholder: "Continuez la conversation…",
    send: "Envoyer",
    disclaimer:
      "L’assistant peut se tromper. Vérifiez les détails importants dans votre dashboard.",
    thinking: "Je consulte le contexte autorisé de votre compte…",
    replyFailed: "L’assistant n’a pas pu répondre",
    loadFailed: "Impossible de charger cette conversation",
    memories: "Mémoires de l’assistant",
    memoriesCount: "{count} note(s) enregistrée(s)",
    hide: "Masquer",
    manage: "Gérer",
    memoryDescription:
      "Ajoutez des préférences ou des informations de travail que l’assistant pourra reprendre dans ses prochaines réponses.",
    memoryLabel: "Note mémoire",
    memoryPlaceholder:
      "Ex. : Je préfère les rapports hebdomadaires en français.",
    saveMemory: "Enregistrer une note",
    memorySaved: "Note enregistrée",
    memoryFailed: "Impossible de modifier cette note",
    deleteMemory: "Supprimer la note",
    noMemories: "Aucune note enregistrée.",
    privacyNote:
      "Les conversations et mémoires sont privées à votre utilisateur et à votre compte marchand. L’assistant ne peut effectuer aucune action financière.",
    contextFreshness:
      "Les données financières sont relues côté serveur à chaque question.",
    realtimeConnected: "Chat en temps réel connecté de façon sécurisée.",
    realtimeConnecting: "Connexion sécurisée au chat en temps réel…",
    connectionLost:
      "La connexion temps réel est interrompue. Reconnectez-vous et réessayez.",
    consentRequired: "Votre accord est requis pour utiliser ces données.",
    deleteConversation: "Supprimer la conversation",
    scheduledWork: "Rapports programmés",
    scheduledWorkSub:
      "L’assistant prépare des analyses en lecture seule, même lorsque vous êtes déconnecté.",
    jobTemplate: "Type de rapport",
    templates: {
      DAILY_PAYMENT_DIGEST: "Résumé quotidien des paiements",
      WEEKLY_ACCOUNT_HEALTH: "Bilan hebdomadaire du compte",
      PENDING_PAYMENT_REVIEW: "Suivi des opérations en attente",
    },
    daily: "Chaque jour",
    weekly: "Chaque semaine",
    scheduleReport: "Programmer le rapport",
    jobCreated: "Rapport programmé",
    jobQueued: "Rapport ajouté à la file de traitement",
    jobFailed: "Impossible de gérer ce rapport",
    nextRun: "Prochaine exécution",
    paused: "En pause",
    enabled: "Actif",
    runNow: "Exécuter maintenant",
    viewReports: "Voir les rapports",
    deleteJob: "Supprimer",
    confirmDeleteJob: "Supprimer ce rapport programmé et son historique ?",
    noScheduledWork: "Aucun rapport programmé.",
    noReports: "Aucun rapport disponible pour le moment.",
    runStatus: {
      QUEUED: "En attente",
      RUNNING: "En cours",
      COMPLETED: "Terminé",
      FAILED: "Échec",
      SKIPPED: "Ignoré",
    },
    scheduledWorkPrivacy:
      "Les rapports programmés sont en lecture seule. Ils ne peuvent ni envoyer ni approuver de paiements ou remboursements.",
  },
  support: {
    title: "Support marchand",
    subtitle: "Échangez avec l’équipe BizConnectPay et suivez vos demandes.",
    adminTitle: "Centre de support",
    adminSubtitle:
      "Traitez les demandes, affectez-les aux équipes compétentes et échangez avec les marchands.",
    ticketList: "Demandes de support",
    live: "Chat en direct",
    connecting: "Connexion…",
    search: "Rechercher une demande",
    allStatuses: "Tous les statuts",
    empty: "Aucune demande pour le moment.",
    newTicket: "Nouvelle demande",
    subject: "Sujet",
    category: "Catégorie",
    message: "Décrivez votre demande",
    create: "Créer la demande",
    created: "Demande créée",
    createFailed: "Impossible de créer la demande",
    loadFailed: "Impossible de charger les demandes",
    updateFailed: "Impossible de mettre à jour la demande",
    connectionFailed: "Impossible d’ouvrir le chat sécurisé",
    replyFailed: "Impossible d’envoyer le message",
    replyPlaceholder: "Écrivez votre message…",
    send: "Envoyer",
    admin: "Support BizConnectPay",
    merchant: "Marchand",
    system: "Système",
    internalNote: "Note interne",
    noAccess: "Votre rôle ne permet pas de gérer les demandes de support.",
    selectTitle: "Choisissez une demande",
    selectBody:
      "Sélectionnez une conversation ou créez une nouvelle demande de support.",
    adminEmpty: "Les demandes de votre file apparaîtront ici.",
    secureChat: "Les messages sont enregistrés dans l’historique du ticket.",
    status: {
      OPEN: "Ouvert",
      IN_PROGRESS: "En cours",
      WAITING_MERCHANT: "En attente du marchand",
      RESOLVED: "Résolu",
      CLOSED: "Fermé",
    },
    categories: {
      GENERAL: "Général",
      PAYMENT: "Paiement",
      PAYOUT: "Retrait",
      REFUND: "Remboursement",
      BILLING: "Facturation",
      TECHNICAL: "Technique",
      API: "API",
      WEBHOOK: "Webhook",
      ACCOUNT: "Compte",
      VERIFICATION: "Vérification",
      COMPLIANCE: "Conformité",
      RISK: "Risque",
      SECURITY: "Sécurité",
    },
  },
  notifications: {
    title: "Notifications",
    sub: "Gérez vos forfaits, alertes par e-mail, SMS et connectez votre compte WhatsApp pour le double facteur (2FA).",
    preferences: "Préférences",
    refresh: "Actualiser",
    allStatuses: "Toutes",
    unread: "Non lues",
    read: "Lues",
    allTypes: "Tous types",
    emptyNotices: "Aucune notification",
    emptySub: "Rien à signaler pour ces filtres.",
    markAllRead: "Tout marquer comme lu",
    notificationDetails: "Détails",
    loadingTitle: "Chargement",
    tabPlans: "Plans & Forfaits",
    tabTemplates: "Modèles clients",
    tabWhatsApp: "Connexion WhatsApp",
    tabHistory: "Historique & Messages",
    templatesTitle: "Modèles de notification client",
    templatesSub:
      "Créez vos propres modèles pour les notifications envoyées par votre intégration API. Les destinataires verront votre marque et votre contenu.",
    addTemplate: "Nouveau modèle",
    templateEmpty: "Aucun modèle personnalisé",
    templateEmptySub:
      "Créez un modèle puis envoyez son code et ses variables avec l’API de notifications.",
    editTemplate: "Modifier le modèle",
    templateCode: "Code du modèle",
    templateChannel: "Canal",
    templateLanguage: "Langue",
    templateSubject: "Objet (e-mail)",
    templateBody: "Message",
    templateBrand: "Nom de marque affiché",
    templateActive: "Modèle actif",
    templateDisabled: "Modèle désactivé",
    templateBodyHelp:
      "Insérez vos variables au format {{nom_variable}}. Fournissez-les à chaque envoi API.",
    saveTemplate: "Enregistrer",
    cancelTemplate: "Annuler",
    deleteTemplate: "Supprimer",
    confirmDeleteTemplate: "Supprimer ce modèle ?",
    templateEmail: "E-mail",
    templateSms: "SMS",
    templateWhatsApp: "WhatsApp",
    activePlan: "Forfait actuel",
    subscribedTo: "Vous êtes abonné au forfait {plan}",
    noActiveSubscription: "Aucun abonnement actif",
    noActiveSubscriptionDesc:
      "Souscrivez à un forfait pour envoyer des alertes SMS et WhatsApp automatisées à vos clients.",
    expiresOn: "Expire le {date}",
    autoRenewEnabled: "Renouvellement automatique activé",
    autoRenewDisabled: "Renouvellement automatique désactivé",
    enableAutoRenew: "Activer le renouvellement auto",
    disableAutoRenew: "Désactiver le renouvellement auto",
    cancelSubscription: "Résilier l'abonnement",
    todayUsage: "Consommation journalière",
    totalNotificationsSent: "Notifications globales envoyées aujourd'hui",
    whatsAppSent: "Messages WhatsApp envoyés aujourd'hui",
    availablePlans: "Forfaits disponibles",
    subscribeBtn: "Souscrire à ce plan",
    subscribeModalTitle: "Souscrire au forfait {plan}",
    selectWallet: "Sélectionnez le portefeuille à débiter",
    autoRenewCheckbox:
      "Activer le renouvellement automatique à échéance (mensuel)",
    confirmSubscribe: "Payer et activer le forfait",
    subscriptionSuccess: "Abonnement activé avec succès !",
    subscriptionCancelled: "Abonnement résilié avec succès.",
    autoRenewUpdated: "Renouvellement automatique mis à jour.",
    channelsIncluded: "Canaux inclus",
    maxDailyGlobal: "Notifications globales / jour",
    maxDailyWhatsApp: "Messages WhatsApp / jour",
    pricePerMonth: "{price} XAF / mois",
    noWalletSelected:
      "Veuillez sélectionner un portefeuille avec un solde suffisant.",
    insufficientFunds:
      "Solde insuffisant sur ce portefeuille pour payer le forfait.",
    whatsAppTitle: "Connexion WhatsApp",
    whatsAppDesc:
      "Associez votre session WhatsApp pour recevoir vos alertes de sécurité, notifications de transactions et vos codes de double authentification (2FA).",
    whatsAppNoticeIndividual:
      "En tant que compte individuel, cette connexion WhatsApp vous permet de recevoir et valider vos codes 2FA directement sur votre application WhatsApp.",
    statusConnected: "Connecté",
    statusConnecting: "Connexion en cours…",
    statusDisconnected: "Déconnecté",
    statusQrReady: "QR Code prêt à être scanné",
    statusPairingReady: "Code de jumelage généré",
    connectedNumber: "Numéro connecté",
    disconnectBtn: "Déconnecter la session",
    disconnectConfirm:
      "Êtes-vous sûr de vouloir déconnecter votre session WhatsApp ?",
    qrModeTab: "Scanner un QR Code",
    pairingModeTab: "Code de jumelage (Pairing code)",
    scanQrTitle: "Scannez le QR Code avec WhatsApp",
    scanQrInstructions:
      "1. Ouvrez WhatsApp sur votre smartphone.\n2. Allez dans Paramètres / Menu > Appareils connectés.\n3. Touchez 'Connecter un appareil' et visez cet écran.",
    refreshQrBtn: "Rafraîchir le QR code",
    pairingTitle: "Lier avec votre numéro de téléphone",
    pairingInstructions:
      "Entrez votre numéro WhatsApp au format international pour recevoir un code à 8 chiffres.",
    pairingPhonePlaceholder: "Ex: 699001122",
    generatePairingCode: "Générer le code de jumelage",
    pairingCodeLabel: "Saisissez ce code dans WhatsApp :",
    enterPairingPrompt:
      "Sur votre téléphone, ouvrez WhatsApp > Appareils connectés > Connecter un appareil > Lier avec un numéro de téléphone.",
    disconnectSuccess: "Session WhatsApp déconnectée.",
  },
  checkout: {
    paymentInfo: "Informations de paiement",
    country: "Pays",
    selectCountry: "Sélectionnez votre pays",
    operator: "Opérateur",
    selectOperator: "Sélectionnez votre opérateur",
    phone: "Numéro de téléphone",
    phonePlaceholder: "Ex: 6XXXXXXXX",
    otpCode: "Code OTP",
    otpPlaceholder: "Saisissez le code reçu",
    otpHelp:
      "Cette méthode exige un code de validation envoyé par votre opérateur.",
    email: "Adresse e-mail (reçu optionnel)",
    emailPlaceholder: "vous@exemple.com",
    pay: "Payer",
    processing: "Traitement en cours…",
    simpleAndSecure: "Paiement simple et sécurisé",
    secure100: "Paiement 100% sécurisé",
    support247: "Support client 24/7",
    orderSummary: "Récapitulatif de la commande",
    paymentFor: "Paiement pour {merchant}",
    validUntil: "Valable jusqu'au {date}",
    amount: "Montant",
    processingFee: "Frais de traitement",
    total: "Total",
    merchantAmountNotice:
      "Montant marchand : {amount} (converti automatiquement)",
    requestSent: "Demande de paiement envoyée",
    validateOnPhone:
      "Validez maintenant la transaction sur votre téléphone ({phone}).",
    reference: "Référence : {ref}",
    invalidLink: "Lien de paiement invalide.",
    securedBy: "Sécurisé par BizConnectPay",
  },
  locked: {
    title: "Module restreint",
    desc: "Ce module nécessite la validation complète de votre dossier d'entreprise (KYB).",
    unlockAction: "Compléter ma vérification",
    businessOnlyTitle: "Module réservé aux comptes entreprise",
    businessOnlyDesc:
      "Ce module nécessite un espace entreprise actif avec KYB approuvé. Créez votre espace entreprise depuis la page Comptes, puis complétez son dossier KYB. Votre compte individuel est conservé.",
    createBusinessBtn: "Créer un espace entreprise",
    moduleWhat: "Le module {title}",
    modules: {
      equipe: {
        title: "Équipe",
        desc: "Inviter des membres, attribuer des rôles (FINANCE, DEVELOPER…) et gérer les accès.",
      },
      developpeurs: {
        title: "Développeurs",
        desc: "Applications, identifiants API, liste d'IP autorisées, webhooks et bascule Sandbox / Live.",
      },
      liens: {
        title: "Liens de paiement",
        desc: "Créer des liens d'encaissement partageables avec montant, devise, expiration et nombre d'utilisations.",
      },
    },
  },
  notFound: {
    title: "404 · Page introuvable",
    sub: "La page que vous recherchez n'existe pas ou a été déplacée.",
    backHome: "Retour au tableau de bord",
  },
};
